import { defineStore } from 'pinia';
import { SET_ENV_PROPS } from '~/types/mutations';

export const useEnvPropsStore = defineStore('envProps', {
  state: () => ({
    envProps: null,
  }),
  actions: {
    [SET_ENV_PROPS](envProps) {
      this.envProps = envProps;
    },
  },
});
